/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `LocationOnIconProps` interface defines the properties for the LocationOnIcon component.
 */
interface LocationOnIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "location_on" — outlined, weight 300.
 * Location pin icon for waypoints display.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const LocationOnIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'LocationOnIcon',
    width
}: LocationOnIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 66q-7 0-13-2t-12-7q-133-119-201.5-227.5T185-552q0-130 83.5-215T480-852q128 0 211.5 85T775-552q0 87-68.5 195.5T505-129q-6 5-12 7t-13 2Zm0-456Z" />
    </svg>
);

LocationOnIcon.displayName = 'LocationOnIcon';